import { Shield, Lock, CreditCard, CheckCircle } from "lucide-react";
import { useLanguageStore } from "@/stores/languageStore";

export const TrustSection = () => {
  const { t } = useLanguageStore();

  const features = [
    {
      icon: Shield,
      titleKey: "trust.pciTitle",
      descKey: "trust.pciDesc",
    },
    {
      icon: Lock,
      titleKey: "trust.sslTitle",
      descKey: "trust.sslDesc",
    },
    {
      icon: CreditCard,
      titleKey: "trust.3dsTitle",
      descKey: "trust.3dsDesc",
    },
    {
      icon: CheckCircle,
      titleKey: "trust.israelcardTitle",
      descKey: "trust.israelcardDesc",
    },
  ];

  return (
    <section className="py-16 bg-charcoal text-white">
      <div className="container">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/20 border border-primary/30 text-primary mb-4">
            <Shield className="h-4 w-4" />
            <span className="text-sm font-medium">{t("trust.badge")}</span>
          </div>
          <h2 className="font-display text-2xl md:text-3xl font-bold mb-3">
            {t("trust.title")}
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-sm md:text-base">
            {t("trust.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-4 md:p-6 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors text-center"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg gradient-gold flex items-center justify-center mx-auto mb-3">
                <feature.icon className="h-5 w-5 md:h-6 md:w-6 text-white" />
              </div>
              <h3 className="font-display text-sm md:text-base font-semibold text-white mb-1">
                {t(feature.titleKey)}
              </h3>
              <p className="text-xs md:text-sm text-white/60">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
